exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".commission-wrap {\n  display: block;\n  width: 100%;\n}\n\n.commission-wrap .ui.sortable.table thead th {\n  white-space: normal !important;\n}\n\n.ui.buttons {\n  display: inline;\n}\n", ""]);

// exports
